import zip from 'lodash/zip';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  mean,
  linearRegression,
  sampleCorrelation,
  sampleStandardDeviation as stdev
} from 'simple-statistics';

import { getFilteredParametersValuesNotEmpty } from 'store/dataset';

import { round4 } from 'utilities/math';

import DoubleNumericalComponent from './Component';

class DoubleNumericalContainer extends React.PureComponent {
  generateParameterPropsFor (parameter) {
    const name = this.props[`${parameter}Parameter`];
    const values = this.props[`${parameter}ParsedParameterValues`];

    return {
      name,

      mean: round4(mean(values)),
      stdev: values.length >= 2 ? round4(stdev(values)) : 'N/A'
    };
  }

  get numberOfObservations () {
    return this.props.firstParsedParameterValues.length;
  }

  get correlationCoefficient () {
    return (this.props.firstParsedParameterValues.length > 1 && this.props.secondParsedParameterValues.length > 1) ? round4(
      sampleCorrelation(
        this.props.firstParsedParameterValues,
        this.props.secondParsedParameterValues
      )
    ) : 'N/A';
  }

  get linearRegressionProps () {
    const parameterPairs = zip(
      this.props.firstParsedParameterValues,
      this.props.secondParsedParameterValues
    );

    const { m, b } = linearRegression(parameterPairs);

    return {
      slope: round4(m),
      intercept: round4(b)
    };
  }

  get firstParameterProps () {
    return this.generateParameterPropsFor('first');
  }

  get secondParameterProps () {
    return this.generateParameterPropsFor('second');
  }

  render () {
    return (
      <DoubleNumericalComponent
        firstParameterProps={this.firstParameterProps}
        secondParameterProps={this.secondParameterProps}
        numberOfObservations={this.numberOfObservations}
        linearRegressionProps={this.linearRegressionProps}
        correlationCoefficient={this.correlationCoefficient}
      />
    );
  }
}

DoubleNumericalContainer.propTypes = {
  firstParsedParameterValues: PropTypes.arrayOf(PropTypes.number).isRequired,
  secondParsedParameterValues: PropTypes.arrayOf(PropTypes.number).isRequired,

  // eslint-disable-next-line react/no-unused-prop-types
  firstParameter: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  secondParameter: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => ({
  ...getFilteredParametersValuesNotEmpty(
    state,
    props.firstParameter,
    props.secondParameter
  )
});

export default connect(mapStateToProps)(DoubleNumericalContainer);
